import { PaddingExample } from 'components/designSystem/utilityClasses/PaddingExample';
import { UtilityClass } from 'components/designSystem/utilityClasses/UtilityClass';
import { UtilityClassSectionHeader } from 'components/designSystem/utilityClasses/UtilityClassSectionHeader';
import { Section } from 'components/shared/Section';

const padding = [
    <UtilityClassSectionHeader key="1" />,
    <div key="2">
        <UtilityClass
            className=".padding__top--xx-small"
            example={<PaddingExample className="padding__top--xx-small" />}
        />
        <UtilityClass
            className=".padding__top--x-small"
            example={<PaddingExample className="padding__top--x-small" />}
        />
        <UtilityClass
            className=".padding__top--small"
            example={<PaddingExample className="padding__top--small" />}
        />
        <UtilityClass
            className=".padding__top--medium"
            example={<PaddingExample className="padding__top--medium" />}
        />
        <UtilityClass
            className=".padding__top--large"
            example={<PaddingExample className="padding__top--large" />}
        />
        <UtilityClass
            className=".padding__top--x-large"
            example={<PaddingExample className="padding__top--x-large" />}
        />
        <UtilityClass
            className=".padding__top--xx-large"
            example={<PaddingExample className="padding__top--xx-large" />}
        />
        <UtilityClass
            className=".padding__bottom--xx-small"
            example={<PaddingExample className="padding__bottom--xx-small" />}
        />
        <UtilityClass
            className=".padding__bottom--x-small"
            example={<PaddingExample className="padding__bottom--x-small" />}
        />
        <UtilityClass
            className=".padding__bottom--small"
            example={<PaddingExample className="padding__bottom--small" />}
        />
        <UtilityClass
            className=".padding__bottom--medium"
            example={<PaddingExample className="padding__bottom--medium" />}
        />
        <UtilityClass
            className=".padding__bottom--large"
            example={<PaddingExample className="padding__bottom--large" />}
        />
        <UtilityClass
            className=".padding__bottom--x-large"
            example={<PaddingExample className="padding__bottom--x-large" />}
        />
        <UtilityClass
            className=".padding__bottom--xx-large"
            example={<PaddingExample className="padding__bottom--xx-large" />}
        />
        <UtilityClass
            className=".padding__left--xx-small"
            example={<PaddingExample className="padding__left--xx-small" />}
        />
        <UtilityClass
            className=".padding__left--x-small"
            example={<PaddingExample className="padding__left--x-small" />}
        />
        <UtilityClass
            className=".padding__left--small"
            example={<PaddingExample className="padding__left--small" />}
        />
        <UtilityClass
            className=".padding__left--medium"
            example={<PaddingExample className="padding__left--medium" />}
        />
        <UtilityClass
            className=".padding__left--large"
            example={<PaddingExample className="padding__left--large" />}
        />
        <UtilityClass
            className=".padding__left--x-large"
            example={<PaddingExample className="padding__left--x-large" />}
        />
        <UtilityClass
            className=".padding__left--xx-large"
            example={<PaddingExample className="padding__left--xx-large" />}
        />
        <UtilityClass
            className=".padding__right--xx-small"
            example={<PaddingExample className="padding__right--xx-small" />}
        />
        <UtilityClass
            className=".padding__right--x-small"
            example={<PaddingExample className="padding__right--x-small" />}
        />
        <UtilityClass
            className=".padding__right--small"
            example={<PaddingExample className="padding__right--small" />}
        />
        <UtilityClass
            className=".padding__right--medium"
            example={<PaddingExample className="padding__right--medium" />}
        />
        <UtilityClass
            className=".padding__right--large"
            example={<PaddingExample className="padding__right--large" />}
        />
        <UtilityClass
            className=".padding__right--x-large"
            example={<PaddingExample className="padding__right--x-large" />}
        />
        <UtilityClass
            className=".padding__right--xx-large"
            example={<PaddingExample className="padding__right--xx-large" />}
        />
        <UtilityClass
            className=".padding__around--xx-small"
            example={<PaddingExample className="padding__around--xx-small" />}
        />
        <UtilityClass
            className=".padding__around--x-small"
            example={<PaddingExample className="padding__around--x-small" />}
        />
        <UtilityClass
            className=".padding__around--small"
            example={<PaddingExample className="padding__around--small" />}
        />
        <UtilityClass
            className=".padding__around--medium"
            example={<PaddingExample className="padding__around--medium" />}
        />
        <UtilityClass
            className=".padding__around--large"
            example={<PaddingExample className="padding__around--large" />}
        />
        <UtilityClass
            className=".padding__around--x-large"
            example={<PaddingExample className="padding__around--x-large" />}
        />
        <UtilityClass
            className=".padding__around--xx-large"
            example={<PaddingExample className="padding__around--xx-large" />}
        />
    </div>,
];

export const Padding = () => <Section title="Padding Utility Classes" contentArray={padding} />;
